import { FacetName, FilterName } from '../../__generated__/fed-graphql-types'
import { withFilterContext } from '../hocs/filter.context.hoc'
import { withFacetContext } from '../hocs/facet.context.hoc'
import { SearchFiltersDropdown } from '../../components/search-filters-dropdown/search-filters-dropdown'

export const BatteryRange = withFacetContext(
    FacetName.battery_range_values,
    withFilterContext(FilterName.battery_range_values, SearchFiltersDropdown, {
        title: 'Battery range',
        hideLabel: true,
    })
)
